import { render, staticRenderFns } from "./BtnExcluirFase.vue?vue&type=template&id=21f1aa68&"
import script from "./BtnExcluirFase.vue?vue&type=script&lang=js&"
export * from "./BtnExcluirFase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports